import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { Heading, Text } from '../../../../components/Typography/Typography';
import EvaluationScore from '../../../../components/EvaluationScore/EvaluationScore';
import styles from '../EvaluationsPage.module.scss';

const EvaluationsHeader: React.FC = () => {
  const { groups } = useSelector((state: RootState) => state.evaluation);

  // Transform evaluations into scores array
  const allScores = groups.flatMap((group) =>
    group.evaluations.map((evaluation) => ({
      name: evaluation.name || 'Unknown',
      score: evaluation.score,
    })),
  );

  return (
    <div className={styles.pageHeader}>
      <Heading level={1}>Evaluations</Heading>
      <Text weight="medium" color="neutral-600">
        Average Score: <EvaluationScore scores={allScores} />
      </Text>
    </div>
  );
};

export default EvaluationsHeader;
